import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@mds/authentication';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReAuthenticationGuard implements CanActivate {
  constructor(private readonly authService: AuthenticationService) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.requiresReAuthentication().pipe(
      map((requiresReAuth) => {
        if (requiresReAuth) {
          this.authService.reAuthenticate(state.url);
        }

        return !requiresReAuth;
      })
    );
  }
}
